// Liste des code immeuble Hopper
export const PORTEFEUILLES = ['HO2', 'PR2']

// Permet de savoir si le contrat est un contrat Hopper
export const estUnContractHopper = (portefeuille: string) => {
    let estHopper = false

    PORTEFEUILLES.forEach((building) => {
        if (building === portefeuille) {
            estHopper =  true
        }
    })
    return estHopper
}
